import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function BalanceSheet() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState([]);
    const fetchBalanceSheet = () => {
        const start = startDate
            ? startDate.toISOString().substring(0, 10)
            : '';
        const end = endDate
            ? endDate.toISOString().substring(0, 10)
            : '';
        axios.get(`${baseUrl}balance-sheet/?start=${start}&end=${end}`)
            .then(res => {
                const rows = [
                    {
                        id: 1,
                        type: 'Total Assets',
                        amount: res.data.assets
                    },
                    {
                        id: 2,
                        type: 'Total Liabilities',
                        amount: res.data.liabilities
                    },
                    {
                        id: 3,
                        type: 'Equity',
                        amount: res.data.equity
                    }
                ];
                setData(rows);
            })
            .catch(err => console.log(err));
    };
    useEffect(() => {
        fetchBalanceSheet();
    }, [startDate, endDate]);
    const columns = [
        {
            field: 'type',
            headerName: 'Description',
            width: 300
        },
        {
            field: 'amount',
            headerName: 'Amount',
            width: 200
        },
    ];
    return (
        <section className='container mt-4'>

            <h3 className='bg-info text-white text-center p-2'>
                Balance Sheet
            </h3>

            <div className="row mb-3">

                <div className="col-md-3">
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="From Date"
                        className="form-control"
                    />
                </div>

                <div className="col-md-3">
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="To Date"
                        className="form-control"
                    />
                </div>

            </div>

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid
                    className="mt-4"

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}

                    rows={data}
                    columns={columns}
                    autoHeight
                    pageSize={10}

                    slots={{
                        toolbar: GridToolbar,
                    }}
                />

            </div>

        </section>
    )
}
export default BalanceSheet;